"use strict";

exports.__esModule = true;
exports.array = void 0;

var _util = require("../../util");

var array = (0, _util.wrapSyncFunc)(function (rule, value) {
  return Array.isArray(value);
});
exports.array = array;